import { connect } from 'react-redux';
import {
  getElementTickmarksAndUpdateElementCache,
  attachTickmarkToElement,
  detachTickmarkFromElement,
} from 'store/actions/element-panel-actions';
import ElementTickmarkPanel from 'components/feature/element-panel/tickmark-panel/element-tickmark-panel-component';
import { searchTickmarksByRevisionAndElementRequest } from 'api/tickmark-api';
import { deallocateItems } from 'store/actions/statement-content-actions';
import { selectElementContentPanel } from 'store/actions/action-creators';
import { updateElementCacheByCalloutAction } from 'store/actions/element-cache-actions';

const mapStateToProps = (
  {
    data,
    sockets: {
      statementSocket: { socketHasBeenDisconnected },
    },
    ui: {
      statementPage: { sectionsInView },
    },
  },
  ownProps,
) => {
  const {
    selectedStatement,
    elementPanel: { tickmarkList, elementDetails },
    selectedProject: { id },
  } = data;
  return {
    ...ownProps,
    selectedStatement,
    tickmarkList,
    elementDetails,
    selectedProjectId: id,
    onSearchTickmark: searchTickmarksByRevisionAndElementRequest,
    socketHasBeenDisconnected,
    stateData: data,
  };
};

const mapDispatchToProps = {
  onCreateTickmark: getElementTickmarksAndUpdateElementCache,
  onAttachTickmark: attachTickmarkToElement,
  onDetachTickmark: detachTickmarkFromElement,
  deallocateItems,
  selectElementContentPanel,
  updateElementCacheByCalloutAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ElementTickmarkPanel);
